<template>
  <div class="itemBox" @mouseenter="showQRCode" @mouseleave="hideQRCode">
    <div class="itemShow" v-show="!showFlag">
      <div class="img">
        <img :src="itemInfoList[hoverIndex-1].img" alt />
      </div>
      <div class="text">{{itemInfoList[hoverIndex-1].text}}</div>
      <div class="detail">{{itemInfoList[hoverIndex-1].detail}}</div>
    </div>
    <div class="hoverShow" v-show="showFlag">
      <div class="img">
        <img src="~@/assets/img/footer/qrCode2.png" alt />
      </div>
      <div class="text">
        <div class="top">扫码下载</div>
        <div class="bottom">开启您的掘金之路</div>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from "@/assets/img/home/qsz1.png";
import img2 from "@/assets/img/home/qsz2.png";
import img3 from "@/assets/img/home/qsz3.png";
import img4 from "@/assets/img/home/qsz4.png";
export default {
  name: "hover",
  props: ["hoverIndex"],
  data() {
    return {
      showFlag: false,
      itemInfoList: [
        { img: img1, text: "入驻开店免费培训" ,detail:'官方图文视频教程，教你快速开店运营店铺。'},
        { img: img2, text: "手机快速发布商品" ,detail:'手机随时随地上传商品信息，开启您的移动店铺。'},
        { img: img3, text: "一对一在线客户服务" ,detail:'在线客服专员一对一服务，随时为您解答疑惑。'},
        { img: img4, text: "商家激励扶持计划" ,detail:'免费提供首页展示、好店推荐，提高曝光率。'}
      ]
    };
  },
  mounted() {
    console.log(this.hoverIndex);
  },
  methods: {
    showQRCode() {
      this.showFlag = true;
    },
    hideQRCode() {
      this.showFlag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.itemBox {
  width: 285px;
  height: 214px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(204, 204, 204, 0.35);
  // border: 1px solid;
  border-radius: 4px;
  text-align: center;
  .itemShow {
    overflow: hidden;
    .img {
      width: 60px;
      height: 60px;
      margin: 36px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      text-align: center;
      font-size: 20px;
      color: #333333;
      margin-top: 40px;
      line-height: 20px;
    }
    .detail{
      font-size: 14px;
      color: #666;
      line-height: 18px;
      width: 200px;
      margin: 10px auto 0;
    }
  }
  .hoverShow {
    overflow: hidden;
    .img {
      width: 100px;
      height: 100px;
      margin: 30px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      text-align: center;
      overflow: hidden;
      .top {
        font-size: 20px;
        color: #333;
        margin-top: 10px;
        line-height: 20px;
      }
      .bottom {
        font-size: 14px;
        color: #666;
        margin-top: 10px;
        line-height: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/components/hoverItem2.vue